module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$emit('details')
      }
    }
  }, [_c('v-list-tile-action', [(_vm.args.pass) ? _c('v-icon', {
    staticClass: "icon green--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("check")]) : _c('v-icon', {
    staticClass: "icon red--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("clear")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.args.pass) ? _c('span', [_vm._v("The vote passed")]) : _c('span', [_vm._v("The vote failed")]), _c('span', {
    domProps: {
      "textContent": _vm._s(', ')
    }
  }), _c('span', [_vm._v(_vm._s(_vm.args.votes.ja.length) + " to " + _vm._s(_vm.args.votes.nein.length))])]), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.president.name) + " and " + _vm._s(_vm.chancellor.name))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f7c6ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/vote/preview.vue
// module id = 313
// module chunks = 0